import React from "react";
import { createRoot } from "react-dom/client";
import { AppRoot } from "./root";
import "./styles/app.css";
import "./styles/admin.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>,
);
